module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page cart-page margin-top-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t\t\t")])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.active_tab == 'cart') ? [(!_vm.cartItems || _vm.cartItems.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Your Cart is Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Looking for something new?")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("Discover")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "min-100",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-4 pt-4",
    attrs: {
      "xs12": "",
      "sm7": "",
      "order-section": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 main-heading"
  }, [_vm._v(_vm._s(_vm.cartItems.length) + " items in cart")]), _vm._v(" "), _c('div', {
    staticClass: "order-container"
  }, _vm._l((_vm.cartItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-content-section pa-0",
      attrs: {
        "sm12": ""
      }
    }, [_c('div', {
      staticClass: "product-cover-image"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('activity-product-card', {
      attrs: {
        "object": item.product,
        "price-show": false
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content"
    }, [_c('div', {
      staticClass: "product-content-row"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.name) + " |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product_variant.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content-row justify-space-between pt-0"
    }, [_c('div', [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (item.product.merchant.slug))
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.merchant.username) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), (!_vm.isDigitalProduct(item)) ? _c('div', [_c('v-btn', {
      staticClass: "product-count-adjust-btn",
      class: {
        active: item.quantity > 1
      },
      attrs: {
        "disabled": item.quantity <= 1
      },
      nativeOn: {
        "click": function($event) {
          _vm.removeQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('label', {
      staticClass: "product-count"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('v-btn', {
      staticClass: "product-count-adjust-btn active",
      nativeOn: {
        "click": function($event) {
          _vm.addQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
      staticClass: "product-action-row justify-space-between"
    }, [_c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.removeCartItem(item)
        }
      }
    }, [_vm._v("Remove")])])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "orders-status-section"
  }, [_c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.subtotal_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.shipping_cost)) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Sales Tax")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.tax_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.fee_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_c('span', [_vm._v("USD")]), _vm._v(" $" + _vm._s(_vm._f("formatNumber")((_vm.cartCost.total_cost + _vm.cartCost.fee_cost))))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "orders-section-container px-5 pt-4",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("All transactions are secure and encrypted.")])]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address-section"
  }, [_c('div', {
    staticClass: "\n\t\t\t\t\t\t\t\t\t\t\td-flex\n\t\t\t\t\t\t\t\t\t\t\tjustify-space-between\n\t\t\t\t\t\t\t\t\t\t\tshipping-action-header\n\t\t\t\t\t\t\t\t\t\t\talign-center\n\t\t\t\t\t\t\t\t\t\t"
  }, [_c('div', {
    staticClass: "stripped-shipping-address"
  }, _vm._l((_vm.strippedAddress), function(line, i) {
    return _c('div', {
      key: i
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(line) + "\n\t\t\t\t\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('div', {
    staticClass: "header-title app-bold flex-none cursor-pointer shipped-btn",
    on: {
      "click": function($event) {
        _vm.editDialog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-address-dialog"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('address-tab')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("All transactions are secure and encrypted.")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('h3', [_vm._v("Credit card")]), _vm._v(" "), _c('div', {
    staticClass: "icon-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cards.png"),
      "alt": "",
      "width": "130"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tand more...\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "stripe-section-body"
  }, [_c('div', {
    staticClass: "lock"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/lock.png"),
      "alt": "",
      "width": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-details"
  }, [_c('div', [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-mark"
  }, [_c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/question.png"),
      "alt": "",
      "width": "40"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Remember me")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "regular-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "c-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c-checkbox"
    }
  }, [_vm._v("Save my information for faster checkout")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section-button"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('v-btn', {
    staticClass: "checkout-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Pay $" + _vm._s(_vm._f("formatNumber")((_vm.cartCost.total_cost + _vm.cartCost.fee_cost))))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "powered-by text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/powered-by.png"),
      "width": "100",
      "alt": ""
    }
  })])])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'history') ? [(!_vm.orderHistories || _vm.orderHistories.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("New Orders")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no orders yet.")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.orderHistories), function(order, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "order-history-item px-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar"
    }, [_c('profile-item', {
      attrs: {
        "user": _vm.currentUser,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_c('b', [_vm._v("You")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("purchased "), _c('b', [_vm._v(" $" + _vm._s(_vm._f("formatNumber")(order.amount)))]), _vm._v(" on "), _c('b', [_vm._v(" " + _vm._s(_vm._f("formatDate")(order.created_at)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "profile-actions"
    }, [_c('div', [(_vm.isMenuAvailable(order)) ? _c('v-menu', {
      staticClass: "menu-content-x",
      attrs: {
        "down": "",
        "offset-y": "",
        "nudge-top": -5
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "round": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
      staticClass: "list-class"
    }, [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.openTicketDialog(order, _vm.item)
        }
      }
    }, [_c('v-list-tile-content', [_c('router-link', {
      staticClass: "order-detail-btn",
      attrs: {
        "to": ("/sell/order/" + (order.id))
      }
    }, [_vm._v("Order Details")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn",
      on: {
        "click": function($event) {
          _vm.showMessageDialog(order)
        }
      }
    }, [_vm._v("Message Buyer")])], 1)], 1), _vm._v(" "), (_vm.isAddressEnabled(order)) ? _c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.openAddressConfimDialog(order)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tRemove my personal info\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])])])], 1), _vm._v(" "), _vm._l((order.items), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "order-section"
      }, [_c('v-layout', {
        staticClass: "border-x",
        attrs: {
          "row": ""
        }
      }, [_c('div', {
        staticClass: "order-content-section relative dflex align-center"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('div', {
        staticClass: "product-content-row"
      }, [_c('div', {
        staticClass: "product-name"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.name) + " |\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product_variant.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
        staticClass: "product-content-row max-width justify-space-between"
      }, [_c('div', {
        staticClass: "product-price"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(item.product_variant.price)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (!_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "product-count"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tQuantity: "), _c('b', [_vm._v(_vm._s(item.quantity))])]) : _vm._e()])])]), _vm._v(" "), (_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "order-status-section digital"
      }, [_c('div', {
        staticClass: "text-xs-center"
      }, [_c('label', [_vm._v(_vm._s(_vm._f("truncateInMiddle")(item.product.digital_content_name, 20)))]), _vm._v(" "), _c('span', {
        staticClass: "product-link",
        on: {
          "click": function($event) {
            _vm.download(item)
          }
        }
      }, [_vm._v("Download")])])]) : _c('div', {
        staticClass: "order-status-section pending",
        class: {
          pending: item.status == 'item_ordered',
          'pending shipped': item.status == 'item_shipped',
        },
        on: {
          "click": function($event) {
            item.status !== 'item_ordered' &&
              _vm.openTrackingInfoDialog(item)
          }
        }
      }, [_c('div', [_c('li', [_vm._v(_vm._s(_vm.order_status[item.status]))]), _vm._v(" "), (item.status === 'item_ordered') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMust ship by "), _c('b', [_vm._v(_vm._s(_vm.getItemDay(item)) + ".")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.getItemDate(item))))]), _vm._v(" or this order is automatically refunded\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.status === 'item_shipped') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tYour item has shipped\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.status == 'item_refunded') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tYour item has refunded\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "dflex align-center justify-space-between"
      }, [_c('div', {
        staticClass: "bold"
      }, [_vm._v("Download")]), _vm._v(" "), _c('v-btn', {
        staticClass: "hollow-btn"
      }, [_vm._v("sample.zip")])], 1)])])], 1)
    })], 2)
  }))] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'cart') ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_order_complete_dialog),
      callback: function($$v) {
        _vm.show_order_complete_dialog = $$v
      },
      expression: "show_order_complete_dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/true.svg"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('div', [_vm._v("Your order was successful")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n\t\t\t\t\t\tWe sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.currentUser.email) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "second-head mt-4"
  }, [_vm._v("\n\t\t\t\t\t\tBuyer protection\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "post mt-2"
  }, [_vm._v("\n\t\t\t\t\t\tSellers have "), _c('b', [_vm._v("21 days")]), _vm._v(" to ship your items or your order is automatically refunded.\n\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 pay_btn",
    attrs: {
      "depressed": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.orderDetails()
      }
    }
  }, [_vm._v("View order details")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": _vm.merchants,
      "amount": _vm.cartCost.total_cost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.orderItems
    }
  }) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_ticket_dialog) ? _c('ticket-new-dialog', {
    attrs: {
      "item": _vm.active_item,
      "dismiss": _vm.closeTicketDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "tracking-info-dialog"
    },
    model: {
      value: (_vm.show_tracking_info_dialog),
      callback: function($$v) {
        _vm.show_tracking_info_dialog = $$v
      },
      expression: "show_tracking_info_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Your item has shipped")]), _vm._v(" "), _c('v-card-text', [(_vm.active_item && _vm.active_item.product) ? _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "product-cover",
    style: (("background-image: url(" + (_vm.active_item.product.covers[0].cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.active_item.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-owner"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.active_item.product.merchant.username) + "\n\t\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("Carrier: ")]), _c('span', {
    staticClass: "red--text"
  }, [_c('b', [_vm._v(_vm._s(_vm.active_item.tracking_site))])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Tracking number: ")]), _c('span', [_vm._v(_vm._s(_vm.active_item.tracking_number))])])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_address_confirm_dialog),
      callback: function($$v) {
        _vm.show_address_confirm_dialog = $$v
      },
      expression: "show_address_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Remove your shipping address?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tThis will remove your shipping address from this user, and user\n\t\t\t\t\tmight not be able to ship your items\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeMyAddress()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAddressConfimDialog()
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adf1e6d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/cart.vue
// module id = 1836
// module chunks = 180